<template>
    <FormGroup :label="attributeName" :required="attribute.is_required">
        <CatalogAttributeSelect :attribute="attribute" :integration="integration" :category="category" :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" />
    </FormGroup>
</template>

<script>
import FormGroup from "../../../../../../components/new/form/group/FormGroup.vue";
import CatalogAttributeSelect from "./CatalogAttributeSelect.vue";

export default {
    name: "CatalogAttributeFormGroup",
    components: { FormGroup, CatalogAttributeSelect },
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: Array,
            default: () => [],
        },
        attribute: {
            type: Object,
            required: true,
        },
        integration: {
            type: Object,
            required: true,
        },
        category: {
            type: Object,
            required: true,
        },
    },
    computed: {
        attributeName() {
            const name = this.attribute.names[this.mainLanguage] || Object.values(this.attribute.names)[0];
            return this.attribute.measurement_unit ? `${name} (${this.attribute.measurement_unit})` : name;
        },
        mainLanguage() {
            return this.integration.language_aliases[0];
        }
    },
}
</script>
